/**
 * Domain template configurations
 * Matches: Domain.VNNIC, Domain.TLDs
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import { defaultQuotaCalculator, defaultIsExpandable } from '../shared'

// ============================================================================
// Fields
// ============================================================================

export const DOMAIN_FIELDS: TemplateField[] = [
    { key: 'domain', names: ['domain'], label: 'Domain' },
]

// ============================================================================
// Template Configs
// ============================================================================

export const domainVNNICTemplate: TemplateConfig = {
    id: 'domain-vnnic',
    patterns: ['domain.vnnic'],
    priority: 10,
    fields: DOMAIN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
}

export const domainTLDsTemplate: TemplateConfig = {
    id: 'domain-tlds',
    patterns: ['domain.tlds'],
    priority: 10,
    fields: DOMAIN_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
}

// Export all domain templates
export const domainTemplates = [domainVNNICTemplate, domainTLDsTemplate]
